import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '40px',
    marginBottom: '1rem',
  },
  image: {
    height: '150px',
    marginBottom: '1rem',
  },
  title: {
    height: '30px',
    marginBottom: '1rem',
  },
  card: {
    main: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '1rem',
      height: '100px',
      marginBottom: '0.5rem',
    },
    text: {
      height: '20px',
      width: '50%',
    },
    button: {
      height: '35px',
      width: '35%',
      alignSelf: 'flex-end',
    },
  },
  disclaimer: {
    height: '20px',
  },
};

const SkeletonPopularDestinationMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, image, title, card, disclaimer } = styles;

  return (
    <Box
      dataTestId="skeletonPopularDestinationsMobile"
      className={`${className} fr-skeleton`}
      style={style}
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={image} />
          <Box className="fr-skeleton-element" style={title} />
          <Box className="fr-skeleton-box" style={card.main}>
            <Box className="fr-skeleton-element" style={card.text} />
            <Box className="fr-skeleton-element" style={card.button} />
          </Box>
          <Box className="fr-skeleton-box" style={card.main}>
            <Box className="fr-skeleton-element" style={card.text} />
            <Box className="fr-skeleton-element" style={card.button} />
          </Box>
          <Box className="fr-skeleton-box" style={card.main}>
            <Box className="fr-skeleton-element" style={card.text} />
            <Box className="fr-skeleton-element" style={card.button} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={disclaimer} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonPopularDestinationMobile.componentName = 'SkeletonPopularDestinationMobile';

export default SkeletonPopularDestinationMobile;
